export default __webpack_public_path__ + "static/tonys_wild_life-098e43397be0cd70b489e6771979c4b9.jpg";